import React from 'react';

const ContentBlock = ({ children }) => {
  return (
    <div className="bg-white p-8 mt-6">
      {children}
    </div>
  );
};

export default ContentBlock;
